module.exports = __webpack_public_path__ + "static/media/windows_top.49a0e194.png";